import React from 'react';
import { motion } from 'framer-motion';
import { BedDoubleIcon, CheckIcon, UsersIcon } from 'lucide-react';
import { properties } from '../../data/units';
import { PropertyId } from '../../types/booking';
import { formatNaira } from '../../utils/format';
export function PropertyPicker({
  value,
  onChange
}: {
  value: PropertyId;
  onChange: (id: PropertyId) => void;
}) {
  return <div role="radiogroup" aria-label="Apartment" className="grid gap-4 sm:grid-cols-2" data-id="element-201" data-mp="k7udj3kqab8x">
      {properties.map(property => {
      const selected = property.id === value;
      return <motion.button key={property.id} type="button" role="radio" aria-checked={selected} onClick={() => onChange(property.id)} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.12
      }} className={`group relative flex flex-col overflow-hidden rounded-sm bg-ivory-50 text-left shadow-soft transition-shadow duration-200 ease-premium ${selected ? 'ring-2 ring-gold-400' : 'ring-1 ring-forest-700/10 hover:shadow-lift'}`} data-id="element-202" data-mp="b760oc72mgxm">
            <span className="relative block overflow-hidden" data-id="element-203" data-mp="1ag9g1hn0l4fm">
              <img src={property.images[0].src} alt={property.images[0].alt} loading="lazy" className="aspect-[16/9] w-full object-cover transition-transform duration-300 ease-premium group-hover:scale-[1.04]" data-id="element-204" data-mp="1pcieigz2zdqz" />
              <span className={`absolute right-3 top-3 inline-flex h-7 w-7 items-center justify-center rounded-full transition-colors duration-150 ${selected ? 'bg-gold-400 text-forest-800' : 'bg-ivory-50/80 text-transparent'}`} aria-hidden="true" data-id="element-205" data-mp="1tdu78vd94f3e">
                <CheckIcon size={15} data-id="element-206" data-mp="2h3y7csr8dwpn" />
              </span>
              <span className="absolute bottom-3 left-3 rounded-full bg-forest-700/85 px-2.5 py-1 text-[10px] tracking-wide text-ivory-100" data-id="element-207" data-mp="2d1tf9ygfl854">
                {property.id}
              </span>
            </span>
            <span className="flex flex-1 flex-col p-5" data-id="element-208" data-mp="2p3ban6t6mezx">
              <span className="font-display text-lg text-forest-700" data-id="element-209" data-mp="2p1qexdv4sq0h">{property.name}</span>
              <span className="mt-2 flex items-center gap-4 text-[12px] text-muted" data-id="element-210" data-mp="2u1mkhhjh8pi5">
                <span className="inline-flex items-center gap-1.5" data-id="element-211" data-mp="2yv77kejj7z2k">
                  <BedDoubleIcon size={13} className="text-gold-500" aria-hidden="true" data-id="element-212" data-mp="32w0vh7wz5dvg" />
                  {property.bedrooms} bedrooms
                </span>
                <span className="inline-flex items-center gap-1.5" data-id="element-213" data-mp="37w5ep5p9ompd">
                  <UsersIcon size={13} className="text-gold-500" aria-hidden="true" data-id="element-214" data-mp="3ctyjbuax98nj" />
                  Max {property.maxGuests}
                </span>
              </span>
              <span className="mt-1.5 text-[12px] text-muted" data-id="element-215" data-mp="1ig5zb6v2211a">{property.amenities.join(' · ')}</span>
              <span className="mt-auto pt-4 font-display text-xl text-forest-700" data-id="element-216" data-mp="1ndpdy7vo0ftr">
                {formatNaira(property.nightlyRate)}
                <span className="ml-1 font-sans text-[11px] text-gold-700" data-id="element-217" data-mp="4knsvgwkb9fk">/ night</span>
              </span>
            </span>
          </motion.button>;
    })}
    </div>;
}